exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "input[type=text]:not(.browser-default){margin:0!important;border-bottom:0!important;box-shadow:none!important}.modal_title{display:flex;justify-content:space-between}", ""]);

// exports
